export default "__VITE_ASSET__BGxsYg9T__"